// The module templates' shared makers (contract §4.8.1): the attributes that
// bind a field or a row slot of the page's module feed, and the CSS every
// module body shares.

import { READOUT_CSS, css } from "./kit.js";

/** The module feed's id on every module page. */
export const FEED = "module";

/** Attributes binding one field of the module feed. */
export const F = (field, extra = {}) => ({
  "data-tc-feed": FEED,
  "data-tc-field": field,
  ...extra,
});

/** Attributes binding one row slot's field (`tank-value` of slot k). */
export const R = (field, slot, extra = {}) => ({
  "data-tc-feed": FEED,
  "data-tc-field": field,
  "data-tc-slot": String(slot),
  ...extra,
});

/** Attributes for one of the feed's series drawn as a path (§4.5.2). */
export const S = (field, extra = {}) => ({
  "data-tc-feed": FEED,
  "data-tc-field": field,
  ...extra,
});

/**
 * The CSS every module body shares: the readout (charts.css), a state flag
 * (a field whose figure is only its state, hidden), the module's own message
 * line (`.overview-module-coming`), the model's honesty line
 * (`.overview-honesty`), and a sparkline lane: its line in the module's
 * kind, its area fading from the kind's top opacity (the page's one
 * gradient, `#mo-a`, which `moduleTemplate` writes where a lane is), and the
 * range chip over a lane of 24 h (cloud ADR 0396, TOM-678).
 */
export const MODULE_CSS =
  READOUT_CSS +
  css(`
  .mo { gap: 0; }
  .rd-xl { font-size: 60px; } .rd-lg { font-size: 46px; } .rd-md { font-size: 34px; } .rd-sm { font-size: 24px; }
  .mo-flag { display: none; }
  .mo-msg { font-size: 15px; color: var(--muted); }
  .mo-msg:empty { display: none; }
  .mo-hon { margin-top: 2px; font-size: 12px; color: var(--muted); }
  .mo-hon:empty { display: none; }
  .mo .rd-l:empty, .mo .rd-l:empty ~ * { display: none; }
  .mo .rd-v:empty { display: none; }
  .mo-end { align-items: flex-end; text-align: right; }
  .mo-end .rd-row { justify-content: flex-end; }
  .mo-g { display: inline-flex; align-self: center; font-size: 0.62em; line-height: 1; margin-right: 0.02em; }
  .mo-g:empty { display: none; }
  .mo-sub { font-size: 13px; color: var(--muted); margin-top: 2px; }
  .mo-sub:empty { display: none; }
  .mo-lane { display: block; width: 100%; flex: 1 1 auto; min-height: 26px; overflow: visible; }
  .mo-lane .ln { fill: none; stroke: var(--_c); stroke-width: 2.4; stroke-linecap: round; stroke-linejoin: round; }
  .mo-lane .ar { fill: url(#mo-a); stroke: none; }
  .mo-lane [data-quality=missing] { display: none; }
  .mo-chip { display: inline-flex; align-items: baseline; gap: 5px; padding: 3px 10px; border-radius: 999px;
    background: var(--surface); font-size: 12px; color: var(--muted); white-space: nowrap; }
  .mo-chip b { font-size: 14px; font-weight: 600; color: var(--text); font-variant-numeric: tabular-nums; }
`);
